"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.init = init;

var _miniCart = require("../modules/mini-cart.js");

var miniCart = _interopRequireWildcard(_miniCart);

var _micromodal = require("micromodal");

var _micromodal2 = _interopRequireDefault(_micromodal);

var _bodyScrollLock = require("body-scroll-lock");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var search = {
    toggle: "[data-toggle-search]",
    search: "[data-search]",
    input: "[data-search-input]"
};

function mobileListener() {
    document.querySelectorAll("[data-mobile-link]").forEach(function (trigger) {
        trigger.addEventListener("click", function () {
            var panelName = trigger.getAttribute("data-mobile-link");
            toggleMainPanel();
            document.querySelector("[data-mobile-panel='" + panelName + "']").classList.toggle("hidden");
        });
    });
}

function backButtonsListener() {
    document.querySelectorAll("[data-mobile-back]").forEach(function (trigger) {
        trigger.addEventListener("click", function () {
            toggleMainPanel();
            trigger.closest("[data-mobile-panel]").classList.toggle("hidden");
        });
    });
}

function toggleSearchListener() {
    document.querySelectorAll(search.toggle).forEach(function (trigger) {
        trigger.addEventListener("click", function () {
            document.querySelector(search.search).classList.toggle("hidden");
            document.querySelectorAll(search.toggle).forEach(function (item) {
                return item.classList.toggle("fill-cerulean");
            });
            var input = document.querySelector(search.input);
            input.focus();
            var val = input.value;
            input.value = '';
            input.value = val;
        });
    });
}

function openMiniCartListener() {
    document.querySelectorAll("[data-mini-cart-open]").forEach(function (trigger) {
        trigger.addEventListener("click", function () {
            closeMobileMenu();
            _micromodal2.default.show('modal-mini-cart');
        });
    });
}

function closeMobileMenuListener() {
    document.querySelector("[data-mobile-close]").addEventListener("click", function () {
        closeMobileMenu();
    });
}

function closeMobileMenu() {
    _micromodal2.default.show('modal-mobile-menu');
    _micromodal2.default.close();
    document.querySelector("[data-mobile-hamburger]").classList.remove("hidden");
    document.querySelector("[data-mobile-close]").classList.add("hidden");
    (0, _bodyScrollLock.clearAllBodyScrollLocks)();
}

function toggleMainPanel() {
    document.querySelector("[data-mobile-panel-main]").classList.toggle("hidden");
}

function accessibility() {
    document.querySelectorAll("[data-menu-parent]").forEach(function (item) {
        item.addEventListener("focus", function (e) {
            document.querySelectorAll(".child-links").forEach(function (submenu) {
                return submenu.classList.remove("menu-open");
            });
            document.querySelectorAll(".child-links").forEach(function (submenu) {
                return submenu.setAttribute('aria-expanded', false);
            });
        });

        item.addEventListener("keypress", function (e) {
            if (this.classList.contains("has-submenu")) {
                if (e.keyCode == 13) {
                    this.parentElement.querySelector(".child-links").classList.add("menu-open");
                    this.parentElement.querySelector(".child-links").setAttribute('aria-expanded', true);
                }
            }
        });
    });
}

_micromodal2.default.init({
    onShow: function onShow(modal) {
        (0, _bodyScrollLock.disableBodyScroll)(modal.getElementsByTagName("div")[0].getElementsByTagName("div")[0]);
        if (modal.id == "modal-mobile-menu") {
            document.querySelector("[data-mobile-hamburger]").classList.add("hidden");
            document.querySelector("[data-mobile-close]").classList.remove("hidden");
        }
    },
    onClose: function onClose(modal) {
        (0, _bodyScrollLock.clearAllBodyScrollLocks)();
        if (modal.id == "modal-mobile-menu") {
            document.querySelector("[data-mobile-hamburger]").classList.remove("hidden");
            document.querySelector("[data-mobile-close]").classList.add("hidden");
        }
        if (modal.id == "modal-mini-cart") {
            document.querySelector("[data-mini-desktop]").classList.remove("hidden");
            document.querySelector("[data-mini-desktop]").classList.remove("md:block");
            document.querySelector("[data-mini-added]").classList.remove("hidden");
        }
    }
});

// Initialize mini cart
miniCart.init();

function init() {
    openMiniCartListener();
    closeMobileMenuListener();
    mobileListener();
    backButtonsListener();
    toggleSearchListener();
    accessibility();
}